// Dependencies
import React, { ChangeEvent, useCallback, useEffect, useState } from "react";
import { Navigate, useSearchParams, useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "react-query";
import { createMonitor } from "../../../api/reactQuery";
import { type } from "os";
import { getMyProfile } from "../../../api/requests";
export default function ProcessRedirect() {

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const { mutate } = useMutation((newMutation : { type: string, name: string, url: string })=>createMonitor(newMutation),{
    onError:()=>{
      // navigate to home page
      navigate("/dashboard/home")
    },
    onSuccess:(response, variable)=>{
      // navigate to home page
      navigate("/dashboard/home")
    }
  })

  useEffect(()=>{
    const domainToRegister = localStorage.getItem("_dmrs");
    const monitorsCounts = searchParams.get("monitorsCount") || '0';

    if(monitorsCounts === '0') {
      if(domainToRegister){
        mutate({
          type: "SSL_MONITORING",
          url: domainToRegister,
          name:"New Domain"
        })
        localStorage.removeItem("_dmrs");
      }
      else {
        navigate("/onboarding/monitor-main")
      }
    }
    else {
      navigate("/dashboard/home")
    }

  },[]);

  return <div>Preparing your dashboard...</div>;
}
